module.exports = __webpack_public_path__ + "static/media/Portrait-10187.02913738.jpg";